module.exports = __webpack_public_path__ + "img/amazonfulfillment.e95acfad.png";